<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="!visibilitySpinnerGuardando" type="button" [disabled]="formInvalid && !docCanBeSaved" class="btn btn-outline-success" (click)="onClickSave()" title="Guardar">
            <i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinnerGuardando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando</button>

        <div *ngIf="!readonly" class="nota-info warning">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> No olvide Guardar la documentación antes de cerrar la ventana.</label>
        </div>
    </form>
</nav>

<div class="animated" class="container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 *ngIf="!readonly">Adjuntar Documento e introducir una descripción para el mismo</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Básicos
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inputTipoDocumentacion">Tipo de Documentación</label>
                                            <ng-select appendTo="body"
                                                [items]="tiposDocumentacion"
                                                bindLabel="IdTipoDocumentacionDescripcion"
                                                bindValue="Id"
                                                formControlName="IdDocumentacionCam"
                                                loadingText="Cargando..."
                                                [loading]="(!tiposDocumentacion || tiposDocumentacion.length === 0)"
                                                placeholder="-- Seleccione un Tipo --"
                                                [ngClass]="displayFieldCssNgSelect('IdDocumentacionCam')"
                                                (change)="onSelectTipo($event)"
                                                notFoundText="Tipo no encontrado"
                                                clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.IdTipoDocumentacionDescripcion }}">{{ item.IdTipoDocumentacionDescripcion }} {{ esObligatoria(item) ? ' (*)': '' }}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div id="validationTipoDocumentacionFeedback" class="invalid-feedback" *ngIf="isFieldInvalid('IdDocumentacionCam','required')">
                                                Tipo de Documentación es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="Obligatoria">Obligatoria</label>
                                            <p-toggleButton formControlName="Obligatoria" name="Obligatoria" class="form-control-togglebutton" onLabel="Sí" offLabel="NO"></p-toggleButton>
                                        </div>

                                    </div>
                                    <div class="row">

                                        <div class="form-group col-md-12">
                                            <label class="col-form-label required-field" for="Descripcion">Descripción</label>
                                            <textarea maxlength="300" [readonly]="readonly" rows="3" formControlName="Descripcion" name="Descripcion" [ngClass]="displayFieldCss('Descripcion')" class="form-control" inputStyleClass="form-control"></textarea>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label required-field" for="NombreArchivo">Fichero Adjunto</label>
                                            <!-- Input para el fichero adjunto -->
                                            <app-document-uploader *ngIf="uploadedFile"
                                                [parentForm]="formGroup" [parentSubmitted]="submitted" [readOnly]="uploaderReadonly" [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit" [required]="true"
                                                [documentModule]="documentModuleCampania"
                                                (fileUploaded)="onFileUploaded($event)" (fileDeleted)="onFileDeleted($event)">
                                            </app-document-uploader>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>

